var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26543 2C4.96805 1.99964 4.67352 2.06146 4.39868 2.18191C4.12384 2.30236 3.87408 2.47908 3.66368 2.70198C3.45329 2.92488 3.28638 3.18957 3.1725 3.48093C3.05862 3.77229 3 4.0846 3 4.4C3 5.72727 4.014 6.82727 5.26286 6.82727C6.51343 6.82727 7.52829 5.72727 7.52829 4.40182C7.52851 4.08649 7.47015 3.77421 7.35653 3.48282C7.24291 3.19143 7.07626 2.92664 6.86612 2.70359C6.65597 2.48053 6.40644 2.30359 6.13178 2.18286C5.85713 2.06214 5.56274 2 5.26543 2ZM16.3157 8.36364C14.4137 8.36364 13.326 9.41818 12.8031 10.4673H12.7483V8.64636H9V22H12.906V15.39C12.906 13.6482 13.0294 11.9645 15.0617 11.9645C17.0649 11.9645 17.094 13.9509 17.094 15.5V22H21V14.6655C21 11.0764 20.2723 8.36364 16.3157 8.36364ZM3.31114 8.64546V22H7.21971V8.64546H3.31114Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.16b0feef5cc8c85d832f07856d4058ae.svg";
export { ForwardRef as ReactComponent };